import PropTypes from 'prop-types';
import styled from 'styled-components';
import { generatePatternStyles } from '@web-stories-wp/patterns';

import StoryPropTypes from '../../types';
import { BACKGROUND_TEXT_MODE } from '../../constants';

const Tint = styled.div`
  position: absolute;
  inset: 0;
  ${({ $backgroundColor, $bounds }) =>
    $backgroundColor &&
    generatePatternStyles($backgroundColor, 'background', null, $bounds)}
`;

const GROUP_STYLE = {
  position: 'absolute',
  inset: 0,
};

const SHADOW_LAYER_STYLE = {
  position: 'absolute',
  pointerEvents: 'none',
  zIndex: 0,
};

export function TextBoxShadow({ style }) {
  if (!style) {
    return null;
  }

  return (
    <div
      aria-hidden="true"
      className="text-box-shadow"
      data-testid="text-box-shadow"
      style={{ ...SHADOW_LAYER_STYLE, ...style }}
    />
  );
}

TextBoxShadow.propTypes = {
  style: PropTypes.object,
};

function TextBoxBackdrop({ element, style, tintRef }) {
  if (!style) {
    return null;
  }

  return (
    <div
      aria-hidden="true"
      className="text-box-backdrop"
      data-testid="text-box-backdrop"
      style={style}
    >
      <Tint
        ref={tintRef}
        className="text-box-backdrop__tint"
        $bounds={element}
        $backgroundColor={
          element.backgroundTextMode === BACKGROUND_TEXT_MODE.NONE
            ? null
            : element.backgroundColor
        }
      />
    </div>
  );
}

TextBoxBackdrop.propTypes = {
  element: StoryPropTypes.elements.text.isRequired,
  style: PropTypes.object,
  tintRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.any }),
  ]),
};

export function TextBoxBackdropGroup({
  element,
  style,
  shadowStyle,
  tintRef,
  children,
}) {
  // Opacity and blending on this ancestor would isolate backdrop-filter from
  // the page. Callers apply those effects to the backdrop and foreground.
  return (
    <div
      className="text-box-backdrop-group"
      data-testid="text-box-backdrop-group"
      style={GROUP_STYLE}
    >
      <TextBoxShadow style={shadowStyle} />
      <TextBoxBackdrop element={element} style={style} tintRef={tintRef} />
      {children}
    </div>
  );
}

TextBoxBackdropGroup.propTypes = {
  element: StoryPropTypes.elements.text.isRequired,
  style: PropTypes.object,
  shadowStyle: PropTypes.object,
  tintRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.any }),
  ]),
  children: PropTypes.node.isRequired,
};

export default TextBoxBackdrop;
